import React, { useState, useEffect, useLayoutEffect } from 'react'

const FadeInOut = React.forwardRef((
    { children, enter, className, onFadeInOutEnd, style }, 
    ref
) => {
    const [trigger, setTrigger] = useState(enter);
    const [render, setRender] = useState(null);

    useEffect(() => {
        if (enter === null || typeof enter === 'undefined') {
            const setTimeoutHandle = setTimeout(() => setTrigger(true));

            return () => clearTimeout(setTimeoutHandle); 
        }
    }, [enter]);
    
    useLayoutEffect(() => {
        if (ref && ref.current) {
            ref.current.style.opacity = 0;
            ref.current.style.transition = null;
        }

        if (trigger !== enter) { setTrigger(Boolean(enter)); }
    }, [enter, ref, trigger]);

    useEffect(() => {
        if (trigger) {
            setRender(children);
        } else {
            setRender(null);
        }
    }, [ trigger, children ]);

    useEffect(() => {
        if (trigger && render && ref && ref.current) {
            ref.current.style.opacity = 1;
            ref.current.style.transition = 'opacity 0.3s cubic-bezier(0.69, 0, 0.33, 1)';
        }
    }, [ref, render, trigger]);

    useEffect(() => {
        const current = ref?.current;
        const onTransitionend = (event) => {
            if (event.target !== current) { return ; }

            if(onFadeInOutEnd){ onFadeInOutEnd(); }
        };

        if (current) { current.addEventListener(
                'transitionend', onTransitionend);
        }

        return () => {
            if (current) {
                current.removeEventListener('transitionend', onTransitionend);
            }
        };
    },[onFadeInOutEnd, ref]);
    
    return  (
        <div 
            className={`fade${className ? ` ${className}` : ''}`} 
            ref={ref} 
            style={style}
        >
            {render}
        </div>
    );
});


export { FadeInOut }
